import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    fitContent: {
        width: '100%',
        height: '100%',
    },
    sizesWrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    boxSizes: {
        display: 'flex',
        flexDirection: 'column',
        background: themes.palette.common.white,
        borderRadius: 20,
        padding: 20,
        width: '100%',
        height: '300px',
        marginBottom: '12px',

        '@media (max-height: 690px)': {
            height: 200,
        },
    },
    boxItem: {
        borderRadius: 42,
        cursor: 'pointer',
        width: '33%',
    },
    boxItemColorPanel: {
        width: 60,
        height: 60,

        '@media (max-height: 690px)': {
            width: 45,
            height: 45,
        },
    },
    spinner: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `1px solid`,
    },
    actionsIcon: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: themes.palette.primary.light,
        // border: `1px solid ${themes.palette.grey['200']}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        border: '1px solid #D1D1D1',
    },
    action: {
        display: 'flex',
        margin: '8px 0 8px 0',
        alignItems: 'flex-end',
        width: 135,
        minHeight: 56,
        justifyContent: 'space-between !important',
    },
}));
